var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-header",attrs:{"pdf-truncation-check-point":""}},[_c('span',{staticClass:"section-number"},[_vm._v(_vm._s(_vm.number))]),_c('h3',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }